import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  deleteCriteriaApiCrud,
  type DeleteCriteriaRequest,
} from "@/generated/fastapi";

export async function deleteCriteria(
  accessToken: string | null | undefined,
  request: DeleteCriteriaRequest,
) {
  const response = await deleteCriteriaApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status === 200) {
    return true;
  }

  throw new Error("Failed to delete criteria");
}
